export function now() {
  return (typeof performance !== 'undefined' && performance && performance.now) ? performance.now() : -1;
}



// WEBPACK FOOTER //
// ./lib/performance.js